import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M16.307 22.96a1.5 1.5 0 0 0 .002 2.049l9.94 10.618a1 1 0 0 0 1.73-.684 218774.52 218774.52 0 0 0-.014-21.937 1 1 0 0 0-1.731-.682L16.307 22.96Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Arrow-Left-Filled_svg__a",
      width: 17,
      height: 28,
      x: 13,
      y: 10,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M29.965 13.005a3 3 0 0 0-5.193-2.045l-9.927 10.635a3.5 3.5 0 0 0 .004 4.78l9.94 10.619a3 3 0 0 0 5.19-2.052 218703.777 218703.777 0 0 0-.014-21.937ZM16.309 25.009a1.5 1.5 0 0 1-.002-2.049l9.927-10.636a1 1 0 0 1 1.731.682 149197.178 149197.178 0 0 0 .014 21.937 1 1 0 0 1-1.73.684l-9.94-10.618Z",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Arrow-Left-Filled_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgArrowLeftFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowLeftFilled_default = SvgArrowLeftFilled;

export { ArrowLeftFilled_default as default };
